import { PoolType } from '../types/pool';

export interface PoolTypeMeta {
  emoji: string;
  label: string;
  bg: string;     // Tailwind bg class for the icon circle
}

const META: Record<PoolType, PoolTypeMeta> = {
  [PoolType.CFP]:                       { emoji: '🏈', label: 'College Football',     bg: 'bg-orange-100' },
  [PoolType.NFL_PLAYOFF]:               { emoji: '🏈', label: 'NFL Playoff',          bg: 'bg-orange-100' },
  [PoolType.NHL_PLAYOFF]:               { emoji: '🏒', label: 'NHL Playoff',          bg: 'bg-sky-100' },
  [PoolType.NBA_PLAYOFF]:               { emoji: '🏀', label: 'NBA Playoff',          bg: 'bg-amber-100' },
  [PoolType.FOUR_NATIONS]:              { emoji: '🏒', label: '4 Nations',            bg: 'bg-sky-100' },
  [PoolType.OLYMPIC_HOCKEY]:            { emoji: '🏒', label: 'Olympic Hockey',       bg: 'bg-sky-100' },
  [PoolType.NCAA_BASKETBALL_PICK6]:     { emoji: '🏀', label: 'NCAA Pick 6',          bg: 'bg-amber-100' },
  [PoolType.NCAA_BASKETBALL_KNOCKOUT]:  { emoji: '🏀', label: 'NCAA Knockout',        bg: 'bg-amber-100' },
  [PoolType.FORMULA_1]:                 { emoji: '🏎️', label: 'Formula 1',            bg: 'bg-red-100' },
  [PoolType.WORLD_CUP_PICK6]:           { emoji: '⚽', label: 'World Cup Pick 6',     bg: 'bg-emerald-100' },
  [PoolType.WORLD_CUP_SURVIVOR]:        { emoji: '⚽', label: 'World Cup Survivor',   bg: 'bg-emerald-100' },
  [PoolType.NFL_NO_REPEAT]:             { emoji: '🏈', label: 'NFL No-Repeat',        bg: 'bg-orange-100' },
};

const FALLBACK: PoolTypeMeta = { emoji: '🏆', label: 'Pool', bg: 'bg-gray-100' };

export function getPoolTypeMeta(type: PoolType | string): PoolTypeMeta {
  return META[type as PoolType] ?? FALLBACK;
}
